import PropTypesUtils from '@utils/propTypes'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Text from '@components/atoms/Text'
import styles from './IconLink.module.scss'

const IconLink = ({ href, link, target, icon, children, whiteIcon }) => {
  const innerJsx = (
    <div className={styles.inner}>
      <i className={`icon icon-${icon} ${whiteIcon ? 'c-white' : 'c-brand'}`} />
      <div className={styles.text}>
        <Text type="nav">{children}</Text>
      </div>
    </div>
  )

  if (href) {
    return (
      <a href={href} target={target} className="c-dark">
        {innerJsx}
      </a>
    )
  }

  if (link) {
    return <Link to={link}>{innerJsx}</Link>
  }

  return innerJsx
}

IconLink.defaultProps = {
  href: false,
  link: false,
  whiteIcon: false,
}
IconLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  icon: PropTypes.string.isRequired,
  whiteIcon: PropTypes.bool,
  children: PropTypesUtils.children,
}

export default IconLink
